<a  
	style="cursor: pointer"  
	class="list-group-item clearfix shadow" 
	[routerLink] = "[product?.id]"
	routerLinkActive = "active"
	>
	<div class="float-left">
		<h4 class="list-group-item-heading">{{product.name}}</h4>
		<p class="list-group-item-text">{{product.description.length>40 ? (product.description | slice:0:40)+'....' : product.description}}</p>  
	</div>
	<span class="float-right">
		<mat-icon (click)="onDelete(product.id)" class ="delete-icon">clear</mat-icon>
		<img *ngIf="product.imageUrl" [src]="product.imageUrl" alt="" class="img-responsive rounded-left" style="max-height: 80px;">
	</span>
</a>